import React, { useEffect } from 'react';
import { Close } from '@linktivity/link-icons';
import { Button } from '@linktivity/link-ui';
import Calendar, { ICalendarProps } from '../Calendar/Calendar';

import styles from './select.module.css';

export interface ISelectCalendarProps
  extends Omit<ICalendarProps, 'className'> {
  open: boolean;
  onClose: () => void;
  title?: string;
}

const SelectCalendar: React.FC<ISelectCalendarProps> = ({
  open,
  onClose,
  title = 'Select Date',
  value,
  onChange,
  disabledDate,
  dateOptions,
  preDateOptions
}) => {
  useEffect(() => {
    if (open) {
      // prevent background scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // restore background scrolling
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  const handleMaskClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleMaskClick}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <Button
            variant="text"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close"
          >
            <Close className={styles.closeIcon} />
          </Button>
          <h2 className={styles.title}>{title}</h2>
        </div>

        <div className={styles.content}>
          <Calendar
            value={value}
            onChange={onChange}
            disabledDate={disabledDate}
            dateOptions={dateOptions}
            preDateOptions={preDateOptions}
            className={styles.calendar}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectCalendar;
